<template>
	
<div class="cates" :class="{'is-small': max === 1000}">

	<div class="cates-title" v-if="title">{{ title }}</div>

	<div class="cates-graph">

		<div class="cates-graph-item" v-for="index in max" :key="index" :class="{'is-issue': index <= issue, 'is-bad': index > max - bad, 'is-change': index > max - bad - change && index <= max - bad}"></div>

	</div>

	<div class="cates-subtitle">For {{ max }} people like you</div>

	<div class="cates-summary">

		<div class="cates-summary-item is-good" v-if="good !== undefined">
			<div class="cates-summary-item-count">{{ good }}</div>
			<div class="cates-summary-item-text">will not {{ action }}</div>
		</div>

		<div class="cates-summary-item is-change" v-if="change !== undefined">
			<div class="cates-summary-item-count">{{ change }}</div>
			<div class="cates-summary-item-text">will avoid {{ action }}</div>
		</div>

		<div class="cates-summary-item is-bad" v-if="bad !== undefined">
			<div class="cates-summary-item-count">{{ bad }}</div>
			<div class="cates-summary-item-text">will {{ action }}</div>
		</div>

		<div class="cates-summary-item is-issue" v-if="issue !== undefined">
			<div class="cates-summary-item-count">{{ issue }}</div>
			<div class="cates-summary-item-text">will have a long-term issue</div>
		</div>

	</div>

</div>

</template>

<script>

export default {
	
	props: ['max', 'title',  'bad', 'issue', 'change', 'action'],

	computed: {

		good: function() {

			return this.max - this.bad - ((this.issue === undefined) ? 0 : this.issue) - ((this.change === undefined) ? 0 : this.change)

		},

		perRow: function() {

			return 10

		}

	}
	
}

</script>

<style scoped>

.cates {
	display: flex;
	flex-direction: column;
	width: 270px;
}

.cates.is-small {
	width: 700px;
}

.cates-title {
	color: #343434;
	font-size: 16px;
	margin-bottom: 16px;
	text-align: center;
	font-weight: 600;
}

.cates-subtitle {
	color: #343434;
	font-size: 16px;
	margin-bottom: 16px;
	text-align: center;
	font-weight: 300;
}

.cates-graph {
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	margin-bottom: 16px;
	width: 270px;
	height: 270px;
}

.cates.is-small .cates-graph {
	width: 700px;
	height: 280px;
}

.cates-graph-item {
	width: 25px;
	height: 25px;
	margin: 1px;
	background-image: url(~@/assets/aid/common/cates/good.svg);
	background-size: 25px 25px;
}

.cates.is-small .cates-graph-item {
	width: 12px;
	height: 12px;
	background-size: 12px 12px;
}

.cates-graph-item.is-bad {
	background-image: url(~@/assets/aid/common/cates/bad.svg);
}

.cates-graph-item.is-change {
	background-image: url(~@/assets/aid/common/cates/change.svg);
}

.is-patient .cates-graph-item.is-change {
	background-image: url(~@/assets/aid/common/cates/change.patient.svg);
}

.cates-graph-item.is-issue {
	background-image: url(~@/assets/aid/common/cates/issue.svg);
}

.cates-summary {
	display: flex;
	flex-direction: row;
}

.cates-summary-item {
	flex-grow: 1;
	flex-shrink: 0;
	flex-basis: 0;
}

.cates-summary-item-count {
	background-color: #343434;
	color: #fff;
	font-size: 35px;
	padding: 16px 8px;
	text-align: center;
	font-weight: 600;
}

.cates-summary-item.is-good .cates-summary-item-count { 
	color: #CBFFF3;
}

.cates-summary-item.is-change .cates-summary-item-count { 
	color: #F8A533;
}

.cates-summary-item.is-bad .cates-summary-item-count { 
	color: #ED7161;
}

.cates-summary-item.is-issue .cates-summary-item-count { 
	color: #714CEB;
}

.cates-summary-item-count:after {
	content: ' ';
	position: absolute;
	top: 8px;
	bottom: 8px;
	width: 1px;
	right: 0px;
	background-color: rgba(255, 255, 255, 0.5);
}

.cates-summary-item:first-child .cates-summary-item-count {
	border-radius: 48px 0px 0px 48px;
}

.cates-summary-item:last-child .cates-summary-item-count {
	border-radius: 0px 48px 48px 0px;
}

.cates-summary-item:last-child .cates-summary-item-count:after {
	display: none;
}

.cates-summary-item-text {
	font-size: 12px;
	font-weight: 600;
	color: #343434;
	text-align: center;
	line-height: 14px;
	padding: 16px 8px;
}

</style>